import { DataTable } from "@/components/data-table";
import { submissionsColumns } from "@/features/dilemmas/components/dilemmas-columns";
import { useTranslation } from "react-i18next";
import EmptyTable from "@/components/empty-table";
import { useSubmissionsList } from "@/features/dilemmas/hooks/useSubmissionsList";
import ListContent from "@/features/dilemmas/components/list-content";
import SearchInput from "@/components/search-input";
import SubmissionsFilterComponent from "@/features/dilemmas/components/submissions-filter-component";
import { useSubmissionsFilterStore } from "@/features/dilemmas/stores";
import { useEffect } from "react";

const SubmissionsListPage = () => {
  const { t } = useTranslation();
  const { dilemmas, page, pageCount, setPage, isLoading, isFetching } =
    useSubmissionsList();
  const {
    searchValue,
    setSearchValue,
    setStatusFilter,
    setOrdering,
    setLanguageFilter,
    setThemeFilter,
  } = useSubmissionsFilterStore();

  useEffect(() => {
    return () => {
      setSearchValue(null);
      setStatusFilter(null);
      setOrdering(null);
      setLanguageFilter(null);
      setThemeFilter(null);
    };
  }, [
    setSearchValue,
    setStatusFilter,
    setOrdering,
    setLanguageFilter,
    setThemeFilter,
  ]);

  return (
    <div className="flex flex-col gap-y-3 pt-3 sm:pt-6 pb-24 relative">
      <div className="flex items-center gap-2 lg:hidden px-3 sm:px-6">
        <SearchInput
          value={searchValue ?? ""}
          onChange={setSearchValue}
          placeholder={t("keys.search")}
        />
        <SubmissionsFilterComponent />
      </div>
      <div className="hidden md:block overflow-x-scroll px-3 sm:px-6">
        <DataTable
          columns={submissionsColumns(t)}
          data={dilemmas}
          page={page}
          pageCount={pageCount}
          onPageChange={setPage}
          isLoading={isLoading || isFetching}
          emptyListComponent={<EmptyTableComponent />}
        />
      </div>
      <ListContent
        data={dilemmas}
        isLoading={isLoading || isFetching}
        page={page}
        pageCount={pageCount}
        onPageChange={setPage}
        className="md:hidden"
        emptyListComponent={<EmptyTableComponent />}
        context="submissions"
      />
    </div>
  );
};

const EmptyTableComponent = () => {
  const { t } = useTranslation();
  return <EmptyTable title={t("modules.dilemmas.datatable.no_submissions")} />;
};

export default SubmissionsListPage;
